import { useDispatch } from 'react-redux';
import { getMuestrasByidMonitoreo } from 'actions/monitoreos.actions';
import { getFileDataUri } from 'utils/file';

const generateImageUri = (base64String) => (base64String ? getFileDataUri(base64String) : null);

const dummyStatus = 'done';
const dummyImgName = 'img.png';

export const useSetImagesFields = () => {
  const dispatch = useDispatch();
  return async (hallazgosFormulario, idFormato, form) => {
    const hallazgos = JSON.parse(JSON.stringify(hallazgosFormulario));
    const { hallazgos: formHallazgos } = form.getFieldsValue();
    for (let i = 0; i < hallazgos.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      const { success, response } = await dispatch(
        getMuestrasByidMonitoreo({
          hallazgo: {
            idMonitoreo: hallazgos[i].idMonitoreo,
            idHallazgo: hallazgos[i].idHallazgo
          }
        })
      );
      const muestras = response.data?.hallazgo?.muestras;
      if (success && muestras) {
        hallazgos[i] = { ...formHallazgos[i] };
        if (muestras[0]?.muestra)
          hallazgos[i].muestra_1 = {
            fileList: [
              {
                uid: 1,
                status: dummyStatus,
                name: dummyImgName,
                url: generateImageUri(response.data.hallazgo.muestras[0]?.muestra),
                thumbUrl: generateImageUri(response.data.hallazgo.muestras[0]?.muestra)
              }
            ]
          };
        if (muestras[1]?.muestra)
          hallazgos[i].muestra_2 = {
            fileList: [
              {
                uid: 2,
                status: dummyStatus,
                name: dummyImgName,
                url: generateImageUri(response.data.hallazgo.muestras[1]?.muestra),
                thumbUrl: generateImageUri(response.data.hallazgo.muestras[1]?.muestra)
              }
            ]
          };
        if (muestras[2]?.muestra)
          hallazgos[i].muestra_3 = {
            fileList: [
              {
                uid: 3,
                status: dummyStatus,
                name: dummyImgName,
                url: generateImageUri(response.data.hallazgo.muestras[2]?.muestra),
                thumbUrl: generateImageUri(response.data.hallazgo.muestras[2]?.muestra)
              }
            ]
          };
        if (muestras[3]?.muestra)
          hallazgos[i].muestra_4 = {
            fileList: [
              {
                uid: 3,
                status: dummyStatus,
                name: dummyImgName,
                url: generateImageUri(response.data.hallazgo.muestras[3]?.muestra),
                thumbUrl: generateImageUri(response.data.hallazgo.muestras[3]?.muestra)
              }
            ]
          };
        if (muestras[4]?.muestra)
          hallazgos[i].muestra_5 = {
            fileList: [
              {
                uid: 5,
                status: dummyStatus,
                name: dummyImgName,
                url: generateImageUri(response.data.hallazgo.muestras[4]?.muestra),
                thumbUrl: generateImageUri(response.data.hallazgo.muestras[4]?.muestra)
              }
            ]
          };
      }
    }

    form.setFieldsValue({ hallazgos });
  };
};
